import { render } from "./Ecological.vue?vue&type=template&id=361a47ca"
import script from "./Ecological.vue?vue&type=script&lang=js"
export * from "./Ecological.vue?vue&type=script&lang=js"
script.render = render

export default script